<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <!-- BEGIN COPYRIGHT -->
        <div class="col-md-6 col-sm-6 padding-top-10">
          {{new Date().getFullYear()}} © Light Platform. ALL Rights Reserved.
          <a href="http://www.beian.miit.gov.cn" style="text-decoration: none"
            >ICP</a
          >
        </div>
        <!-- END COPYRIGHT -->
        <!-- BEGIN PAYMENTS -->
        <div class="col-md-6 col-sm-6"></div>
        <!-- END PAYMENTS -->
      </div>
    </div>
  </div>
</template>
	
<script>
export default {};
</script>

<style scoped="scoped">

.footer {
  background: #272626;
  color: #fff;
  font-size: 12px;
  padding: 15px 0;
}

.footer-light {
  background: #f9f9f9;
  color: #3e4d5c;
}

.footer-gray {
  background: #4a5866;
}

.footer a {
  color: #fff;
  text-decoration-line:none;
  /* text-decoration: underline; */
}

.footer a:hover {
  text-decoration: none;
}

.footer-light a {
  color: inherit;
}

.footer .padding-top-10 {
  opacity: 0.5;
}

.footer .list-inline > li:last-child {
  padding-right: 0;
}

.footer ul {
  margin: 0;
  padding: 0;
}

.footer ul.social-footer {
  font-size: 18px;
  padding-top: 5px;
}

.footer ul.social-footer a {
  opacity: 0.5;
}

.footer ul.social-footer a:hover {
  opacity: 1;
}
</style>
